import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\User\Auth\RegisterInertiaController::showRegistrationForm
* @see app/Http/Controllers/User/Auth/RegisterInertiaController.php:28
* @route '/user/register'
*/
export const showRegistrationForm = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showRegistrationForm.url(options),
    method: 'get',
})

showRegistrationForm.definition = {
    methods: ["get","head"],
    url: '/user/register',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\User\Auth\RegisterInertiaController::showRegistrationForm
* @see app/Http/Controllers/User/Auth/RegisterInertiaController.php:28
* @route '/user/register'
*/
showRegistrationForm.url = (options?: RouteQueryOptions) => {
    return showRegistrationForm.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\Auth\RegisterInertiaController::showRegistrationForm
* @see app/Http/Controllers/User/Auth/RegisterInertiaController.php:28
* @route '/user/register'
*/
showRegistrationForm.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showRegistrationForm.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\RegisterInertiaController::showRegistrationForm
* @see app/Http/Controllers/User/Auth/RegisterInertiaController.php:28
* @route '/user/register'
*/
showRegistrationForm.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: showRegistrationForm.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\User\Auth\RegisterInertiaController::showRegistrationForm
* @see app/Http/Controllers/User/Auth/RegisterInertiaController.php:28
* @route '/user/register'
*/
const showRegistrationFormForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: showRegistrationForm.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\RegisterInertiaController::showRegistrationForm
* @see app/Http/Controllers/User/Auth/RegisterInertiaController.php:28
* @route '/user/register'
*/
showRegistrationFormForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: showRegistrationForm.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\Auth\RegisterInertiaController::showRegistrationForm
* @see app/Http/Controllers/User/Auth/RegisterInertiaController.php:28
* @route '/user/register'
*/
showRegistrationFormForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: showRegistrationForm.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

showRegistrationForm.form = showRegistrationFormForm

const RegisterInertiaController = { showRegistrationForm }

export default RegisterInertiaController